<div class="kng-table-loader">
  <table class="table">
    <thead>
      <tr>
        <th *ngFor="let col of numSequence(state.noOfColumns);let i = index">
          <span *ngIf="state.headerArray && state.headerArray.length > 0">{{state.headerArray[i]}}</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let col of numSequence(state.noOfRows)">
        <td *ngFor="let col of numSequence(state.noOfColumns)">
          <div class="gradient-loader"></div>
        </td>
      </tr>
    </tbody>
    </table>
</div>
